interface SimpleLinkProps {
    link: string
    text: string
}

export const SimpleLink = ({link, text}: SimpleLinkProps) => {
    return (
        <div className="text-sm flex items-center font-semibold justify-between [&_a]:ml-2 [&_a]:text-black">
            <span>{'🔗'}</span>{' '}
            <a href={link} target="_blank" rel="noreferrer">
                {' '}
                {text}
            </a>
        </div>
    )
}
